/* Created by Interactive 63 - https://interactive63.com */
/**
 * Evaluates any easing at a progress value, using the same definitions the CSS output uses.
 */
import { BoundedCache } from './cache';
import { cubicBezier, KEYWORD_BEZIERS, type EasingFunction } from './cubic-bezier';
import { evaluatePoints, pointsForEasing } from './linear-fn';
import { steps } from './steps';
import type { Easing } from './types';

const functionCache = new BoundedCache<EasingFunction>(100);

/** Returns the easing at progress t. t is normally 0..1; the result may overshoot 0..1. */
export function evaluateEasing(easing: Easing, t: number): number {
  switch (easing.type) {
    case 'linear':
      return t;
    case 'hold':
      return t < 1 ? 0 : 1;
    case 'keyword':
      return functionCache.get(easing.name, () => {
        const [x1, y1, x2, y2] = KEYWORD_BEZIERS[easing.name];
        return cubicBezier(x1, y1, x2, y2);
      })(t);
    case 'cubic':
      return functionCache.get(JSON.stringify(easing), () =>
        cubicBezier(easing.x1, easing.y1, easing.x2, easing.y2),
      )(t);
    case 'steps':
      return functionCache.get(JSON.stringify(easing), () => steps(easing.count, easing.position))(
        t,
      );
    case 'spring':
    case 'bounce':
    case 'elastic':
      return evaluatePoints(pointsForEasing(easing), t);
  }
}
